import React from "react";

function buildMapsEmbedUrl(mapQuery) {
  const params = new URLSearchParams({
    q: mapQuery,
    z: "15",
    output: "embed",
  });

  return `https://www.google.com/maps?${params.toString()}`;
}

function buildMapsSearchUrl(mapQuery) {
  const params = new URLSearchParams({
    api: "1",
    query: mapQuery,
  });

  return `https://www.google.com/maps/search/?${params.toString()}`;
}

function PropertyMap({ mapQuery, title }) {
  const cleanQuery = String(mapQuery || "").trim();
  const mapsSearchUrl = cleanQuery ? buildMapsSearchUrl(cleanQuery) : "";

  return (
    <aside className="property-map" aria-label={`${title} location`}>
      <div className="property-map__frame">
        {cleanQuery ? (
          <iframe
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            src={buildMapsEmbedUrl(cleanQuery)}
            title={`${title} map`}
          />
        ) : (
          <div className="property-map__fallback">
            <p>Map location coming soon.</p>
          </div>
        )}
      </div>

      {cleanQuery ? (
        <a
          className="property-map__link"
          href={mapsSearchUrl}
          rel="noreferrer"
          target="_blank"
        >
          Open location in Google Maps
        </a>
      ) : null}
    </aside>
  );
}

export default PropertyMap;
